import request from "@/utils/request";

//故障分类
export const getFaultClass = (data = {}) => {
  return request({
    url: "Mydb/faulttype_type_lists",
    data
  });
};

//选择客户(外部机构-列表接口)
export const getStoresList = (data = {}) => {
  return request({
    url: "Factory/stores_lists",
    data
  });
};

//选择设备
export const getDeviceList = (data = {}) => {
  return request({
    url: "Device/device_lists",
    data
  });
};

//选择位置
export const getLocation = (data = {}) => {
  return request({
    url: "Mydb/place_lists",
    data
  });
};

//获取设备分类列表
export const getDeviceType = (data = {}) => {
  return request({
    url: "Device/device_type_lists",
    data
  });
};

//获取我家云客户信息
export const getMyHomeCloudCustomer = (data = {}) => {
  return request({
    url: "Stores/stores_room_lists",
    data
  });
};

//获取内部员工信息
export const getStaff = (data = {}) => {
  return request({
    url: "Hqdb/sub_user_lists",
    data: {
      user_type: 1,
      ...data
    }
  });
};

//获取职务信息
export const getPosition = (data = {}) => {
  return request({
    url: "Hqdb/sub_duty_lists",
    data
  });
};

//获取角色信息
export const getRole = (data = {}) => {
  return request({
    url: "Hqdb/sub_role_lists",
    data
  });
};

//获取部门信息
export const getDepartment = (data = {}) => {
  return request({
    url: "Hqdb/sub_department_lists",
    data
  });
};

//获取客户(弹窗里用)
export const getCustomer = (data = {}) => {
  return request({
    url: "Hqdb/sub_customer",
    data
  });
};

//获取专业列表(新建故障分类和新建故障类型时用)
export const getSpecialtyList = (data = {}) => {
  return request({
    url: "Mydb/subgroup_lists",
    data
  });
};
